import { Component, input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-spinner",
  templateUrl: "./spinner.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./spinner.component.scss"],
})
export class SpinnerComponent {
  public readonly size = input(25);

  constructor() {}
}
